import {
  Component,
  OnInit,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  TemplateRef,
  Inject,
  PLATFORM_ID,
  Input
} from '@angular/core';
import {
  tracking_filter_model,
  tracking_preview_model,
} from '../tracking-model';
import { PopoverRef } from 'src/app/shared/popover/popover-ref';
import { PopoverService } from 'src/app/shared/popover/popover.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TrackingService } from '../tracking.service';
import { SharedService } from 'src/app/shared/shared.service';
import { Params } from '@fortawesome/fontawesome-svg-core';
// import html2canvas from 'html2canvas';
import { interval, Subject, Observable, Subscription } from 'rxjs';
import { CoreConfigService } from 'src/app/core/core.service';
import { takeUntil, tap } from 'rxjs/operators';
import { ShortUrl_Model } from 'src/app/core/core.model';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import {
  tracking_response_model,
  tracking_response_item_model,
} from '../tracking-item/tracking-item.model';
import { isPlatformBrowser } from '@angular/common';
import { TrackingVerifyPhone } from '../tracking-verify-phone-dialog/tracking-verify-phone-dialog';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
@Component({
  selector: 'kett-tracking-search',
  templateUrl: './tracking-search.component.html',
  styleUrls: ['./tracking-search.component.scss'],
})


export class TrackingSearchComponent implements OnInit {
  
  ListFilterKey: tracking_filter_model[] = [
    {
      display_key: 'g.filter.all',
      list_status_code: [],
      list_not_status_code: [],
    },
    {
      display_key: 'g.filter.on-going',
      list_status_code: [],
      list_not_status_code: ['POD', '400', '401'],
    },
    {
      display_key: 'g.filter.success-delivered',
      list_status_code: ['POD', '400'],
      list_not_status_code: [],
    },
    {
      display_key: 'g.filter.retuned',
      list_status_code: ['401'],
      list_not_status_code: [],
    },
    {
      display_key: 'g.filter.shipment-found',
      list_status_code: [],
      list_not_status_code: [],
    },
    {
      display_key: 'g.filter.shipment-not-found',
      list_status_code: [],
      list_not_status_code: [],
    },
  ];
  @Input() info: tracking_response_item_model = undefined;
  @ViewChild('resultpanel', {
    static: false,
  })
  resultpanel: ElementRef;

  loadingShareImg = 0;
  loadingShareLink = 0;

  _PopoverRef: PopoverRef;
  ShowNotFound = false;
  PreviewListTracking: tracking_preview_model[] = [];
  SharedLinkSup: Subscription;
  private ngDestroyed$ = new Subject<void>();
  public_url = undefined;
  ListDoneStatus: string[] = ['112', 'POD', '400', '401'];
  Onloading = true;
  ExceedLimit = false;
  LoadedQR = true;

  constructor(
    private _PopoverService: PopoverService,
    private _ActivatedRoute: ActivatedRoute,
    private _Router: Router,
    private _HttpClient: HttpClient,
    private _SharedService: SharedService,
    public _TrackingService: TrackingService,
    private _ChangeDetectorRef: ChangeDetectorRef,
    private _CoreConfigService: CoreConfigService,
    public dialog: MatDialog,

    @Inject(PLATFORM_ID) private platformId: any
  ) { }

  Filter(key_filter: tracking_filter_model) {
    this.PreviewListTracking.forEach((d) => (d.hidden = true));
    let listcon: string[] = [];
    switch (key_filter.display_key) {
      case 'g.filter.on-going':
      case 'g.filter.shipment-process':
      case 'g.filter.shipment-pickup':
      case 'g.filter.success-delivered':
      case 'g.filter.retuned':
        listcon = this._TrackingService.ListResponse.filter(
          (s) => s && s.ref && s.ref.shipment && s.ref.icon
        )
          .filter((s) => {
            return (
              s &&
              s.ref &&
              s.ref.shipment &&
              s.ref.shipment_status &&
              s.ref.icon &&
              (key_filter.list_status_code.length < 1
                ? true
                : key_filter.list_status_code.some(
                  (e) => e == s.ref.icon.display[s.ref.icon.current_idx].code
                )) &&
              (key_filter.list_not_status_code.length < 1
                ? true
                : !key_filter.list_not_status_code.some(
                  (e) => e == s.ref.icon.display[s.ref.icon.current_idx].code
                ))
            );
          })
          .map((s) => s.ref.shipment.con);
        break;
      case 'g.filter.shipment-found':
        this.UpdateShipmentFound(true);
        break;
      case 'g.filter.shipment-not-found':
        this.UpdateShipmentFound(false);
        break;
      default:
        this.PreviewListTracking.forEach((d) => (d.hidden = false));
        break;
    }
    if (listcon.length > 0) {
      this.PreviewListTracking.filter((s) =>
        listcon.some((e) => e == s.tracking_no)
      ).forEach((s) => (s.hidden = false));
    }
    this._ChangeDetectorRef.detectChanges();
  }

  ngOnDestroy() {
    if (this._PopoverRef) this._PopoverRef.close();
    this.ngDestroyed$.next();
    this.ngDestroyed$.complete();
  }

  ResetForm() {
    this.public_url = undefined;
    this.loadingShareImg = 0;
    this.loadingShareLink = 0;
    this.Onloading = true;
    this.ExceedLimit = false;
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this._ActivatedRoute.queryParams
        .pipe(takeUntil(this.ngDestroyed$))
        .subscribe((queryParams: Params) => {
          this.PreviewListTracking = [];
          if (queryParams && queryParams['track']) {
            const delay = interval(500);
            const _subdelay = delay.subscribe((x) => {
              if (this._CoreConfigService.base_config) {
                let decode = this._TrackingService.DecryptOldTrack(
                  queryParams['track']
                );
                if (decode) {
                  this.Onloading = true;
                  let list_tracking: string[] = decode.split(',');
                  this.ResetForm();
                  let tmp_preview = this._TrackingService.BuildNewListTracking(
                    list_tracking.slice(0, 30)
                  );
                  this.PreviewListTracking = tmp_preview;
                  this.ExceedLimit = list_tracking.length > 30;

                  this.GetConsignmentListInfo(
                    list_tracking.slice(0, 30)
                  ).subscribe(
                    (res) => {
                      if (res) {
                        res.forEach(v=>{
                          v.ref&&(v.ref.refoundtype = v?.refoundtype || 0)
                        })
                        for (
                          let index = 0;
                          index < tmp_preview.length;
                          index++
                        ) {
                          let el = tmp_preview[index];
                          let find_result = res.find(
                            (s) =>
                              s.tracking_no == el.tracking_no &&
                              s.ref &&
                              s.ref.shipment &&
                              s.ref.icon
                          );
                          el.isfound = find_result ? true : false;
                          if (el.isfound) {
                            this.GroupStatus(find_result.ref);
                            el.ref = find_result.ref;
                          }
                        }
                      }
                      this._TrackingService.ListTracking_found =
                        tmp_preview.filter((s) => s.isfound).length;
                      this._TrackingService.ListTracking_notfound =
                        tmp_preview.filter((s) => !s.isfound).length;
                      this._TrackingService.ListResponse = res;
                      this.PreviewListTracking = [];
                      if (tmp_preview.length == 1)
                        tmp_preview[0].showdetail = true;
                      this.PreviewListTracking = tmp_preview;
                      this.Onloading = false;
                      this.LoadedQR = false;
                    },
                    (ex) => {
                      this._TrackingService.ListTracking_found =
                        tmp_preview.filter((s) => s.isfound).length;
                      this._TrackingService.ListTracking_notfound =
                        tmp_preview.filter((s) => !s.isfound).length;
                      this.Onloading = false;
                      this.LoadedQR = false;
                    }
                  );
                }

                _subdelay.unsubscribe();
              }
            });
          } else {
            this.LoadedQR = true;
            this._Router.navigate(['']);
          }
        });
    }
  }

  animal: string;
  name: string;
  isExpand = false;

  ChangeDetail(idx, shipment) : void {
    if (this.PreviewListTracking[idx].showdetail)
      this.PreviewListTracking[idx].showdetail = false;
    else {
      this.PreviewListTracking.filter((s) => s.showdetail).forEach(
        (e) => (e.showdetail = false)
      );
      this.PreviewListTracking[idx].showdetail = true;
    }
  }

  GroupStatus(res: tracking_response_item_model) {
    if (res?.shipment_status?.length > 0) {
      res.shipment_status[0].s_checked = this.ListDoneStatus.some(
        (s) => s == res.shipment_status[0].s_code
      );

      res.group_shipment_status = [
        {
          shipment_status: [res.shipment_status[0]],
        },
      ];
      const indexAddStatus = []
      indexAddStatus.push(res.shipment_status[0].indx);
      // res.shipment_status = res.shipment_status.sort((a, b) => b.s_group - a.s_group)
      
      for (let i = 0; i < res.shipment_status.length; i++) {
        const current = res.shipment_status[i];
    
        if(current.wating_time == "" || current.wating_time == undefined ) current.wating_time ="0";
        if(current.talk_time == "" || current.talk_time == undefined ) current.talk_time ="0";
        // if(current.courier_mobile != "" && current.courier_mobile !== undefined && current.courier_mobile != null)
        // {
        //   let phoneMarking = "";
        //   for(let index =0; index < current.courier_mobile.length; index++)
        //   {
        //     phoneMarking = phoneMarking + (index < current.courier_mobile.length -3 ? '*' : current.courier_mobile[index])
        //   } 
        //   current.courier_mobile = phoneMarking;
        // }
      }


      for (let i = 1; i < res.shipment_status.length; i++) {
        const prev = res.shipment_status[i - 1];
        const current = res.shipment_status[i];

        let currentStatusCode = res.shipment_status[i].s_code;
        let prevStatusCode = res.shipment_status[i - 1].s_code;
     
        //045 is DVL 
        const statusIsNotGrouping = ["DEL","060"]
        currentStatusCode = currentStatusCode.length >= 3 ? currentStatusCode.substring(0,3) : currentStatusCode;
        const isStatuscodeReturn = ["091"]
        const isStatuscodeSip = ["105","107","109","105.1","107.1","109.1"]
        const isStatuscodeSop = ["106","108","110","106.1","108.1","110.1"]

        if(indexAddStatus.includes(current.indx))
        {
          continue;
        }
        indexAddStatus.push(res.shipment_status[i].indx);
        if (
          prev.s_date == current.s_date &&
          current.call_number != "" &&
          current.call_number != undefined &&
          current.s_group == prev.s_group &&
          current.s_group != 1 &&
          !statusIsNotGrouping.includes(currentStatusCode) &&
          !isStatuscodeReturn.includes(currentStatusCode) 
        ) {
          res.group_shipment_status[
            res.group_shipment_status.length - 1
          ].shipment_status = [
              ...res.group_shipment_status[res.group_shipment_status.length - 1]
                .shipment_status,
              current,
            ];
        }
        else if (
          prev.s_group == current.s_group &&
          current.s_group == 2 &&
          prev.s_group == 2 
        ) {
          if(isStatuscodeSop.includes(prev.s_code) && isStatuscodeSip.includes(current.s_code))
          {
            res.group_shipment_status[
              res.group_shipment_status.length - 1
            ].shipment_status = [
                ...res.group_shipment_status[res.group_shipment_status.length - 1]
                  .shipment_status,
                current,
              ];
          }
          else
          {
            res.group_shipment_status.push({
              shipment_status: [current],
            });
          }
        }
        else if (
          prev.s_group == current.s_group &&
          current.s_group == 3 &&
          prev.s_group == 3 &&
          isStatuscodeReturn.includes(prevStatusCode) && 
           ( prevStatusCode == currentStatusCode || i == 1) 
        ) {
            res.group_shipment_status.push({
              shipment_status: [prev],
            });
        }
        else if(prev.s_group == current.s_group &&
          current.s_group == 3 &&
          prev.s_group == 3)
        {
          if(isStatuscodeSop.includes(prev.s_code) && isStatuscodeSip.includes(current.s_code))
          {
            res.group_shipment_status[
              res.group_shipment_status.length - 1
            ].shipment_status = [
                ...res.group_shipment_status[res.group_shipment_status.length - 1]
                  .shipment_status,
                  current,
              ];
          }
          else
          {
            res.group_shipment_status.push({
              shipment_status: [current],
            });
          }
        }
        else {
          res.group_shipment_status.push({
            shipment_status: [current],
          });

        }
      }

      res.group_shipment_status[res.group_shipment_status.length - 1].lastnode = true;

    }
  }

  GetConsignmentListInfo(
    tracking: string[]
  ): Observable<tracking_response_model[]> {
    const _tracking = tracking.join(',');
    
    // return this._HttpClient.get<any>('assets/resource/shipment_info_1.txt'); // window.location.href
    // return this._HttpClient.post<any>('/th/track/' +window.location.search, {
    //   tracking_no: _tracking,
    // });
    return this._HttpClient.post<any>(window.location.href, {
      tracking_no: _tracking,
    });
  }

  // http://10.112.85.112:9001/track/api/Shipment/VerifyPhone

  GetConsignmentListInfoVerifyPhone(
    tracking: string[]
  ): Observable<tracking_response_model[]> {
    const _tracking = tracking.join(',');
    //  return this._HttpClient.get<any>('assets/resource/shipment_info.txt');
    return this._HttpClient.post<any>('https://th.kex-express.com/track/api/Shipment/trackingVerifyPhone/', {
      tracking_no: _tracking,
    });
  }

  ShowTemplate(
    content: TemplateRef<any>,
    origin,
    _actionkey: any,
    width?: string
  ) {
    if (this._PopoverRef) this._PopoverRef.close();
    this._PopoverRef = this._PopoverService.open<{}>({
      content,
      origin,
      // width: width ? width : '200px',
    });
    this._PopoverRef.afterClosed$.subscribe(() => {
      _actionkey.value = '';
    });
  }
  CloseTemplate(content: TemplateRef<any>) {
    this._PopoverRef.close();
  }

  UpdateShipmentFound(is_found) {
    this.PreviewListTracking.filter((s) => s.isfound == is_found).forEach(
      (d) => (d.hidden = false)
    );
    this.PreviewListTracking.filter((s) => s.isfound != is_found).forEach(
      (d) => (d.hidden = true)
    );
  }

  // Clipboard() {
  //   try {
  //     html2canvas(this.resultpanel.nativeElement, {
  //       logging: false,
  //     }).then((canvas) => {
  //       let img = document.createElement('img');
  //       img.src = canvas.toDataURL('image/png', 1);

  //       let div = document.createElement('div') as any;

  //       let editable = div.contentEditable;
  //       let readOnly = div.readOnly;

  //       div.contentEditable = true;
  //       div.readOnly = false;

  //       div.appendChild(img);
  //       document.body.appendChild(div);

  //       let range = document.createRange();
  //       range.selectNodeContents(div);

  //       let selection = window.getSelection();
  //       selection.removeAllRanges();
  //       selection.addRange(range);
  //       div.contentEditable = editable;
  //       div.readOnly = readOnly;
  //       document.execCommand('copy');
  //       document.body.removeChild(div);
  //     });
  //   } catch (ex) {
  //   }
  // }

  DownloadImage() {
    var link = document.createElement('a');
    link.href = 'images.jpg';
    link.download = 'Download.jpg';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  // ShareImage(scale, type = 'new_tab') {
  //   try {
  //     html2canvas(this.resultpanel.nativeElement, {
  //       logging: false,
  //       scrollX: 0,
  //       scrollY: -window.scrollY,
  //       scale: 1,
  //     }).then(
  //       (canvas) => {
  //         canvas.style.backgroundColor = 'white';

  //         if (type == 'new_tab') {
  //           let newwindow = window.open('', '_blank');
  //           if (newwindow != null && newwindow != undefined) {
  //             setTimeout(() => {
  //               newwindow.document.write(
  //                 "<div style='background-color:white;padding:20px;width:max-content;'><img width='" +
  //                 100 * scale +
  //                 "%' ; src='" +
  //                 canvas.toDataURL('image/png', 1) +
  //                 "'/></div>"
  //               );
  //               newwindow.document.title = 'KEX Express (Thailand)';
  //             }, 100);
  //           }
  //         } else {
  //           let link = document.createElement('a');
  //           link.href = canvas.toDataURL('image/png', 1);
  //           link.download = 'kerry_tracking.png';
  //           document.body.appendChild(link);
  //           link.click();
  //           document.body.removeChild(link);
  //         }

  //         this.loadingShareImg = 0;
  //       },
  //       () => {
  //         this.loadingShareImg = 0;
  //       }
  //     );
  //   } catch (error) {
  //     this.loadingShareImg = 0;
  //   }
  // }

  generate_public_url(content: TemplateRef<any>, origin, _actionkey: any) {
    if (window) {
      this.loadingShareLink = 1;
      let get_full_url = window.location.href;
      if (this.public_url && this.public_url.longUrl == get_full_url) {
        this.loadingShareLink = 0;
        this.ShowTemplate(content, origin, _actionkey, '300px');
      } else if (
        this.PreviewListTracking.length >
        this._TrackingService.ListTracking_notfound
      ) {
        let get_full_url = window.location.href;
        if (this.SharedLinkSup) this.SharedLinkSup.unsubscribe();
        this.SharedLinkSup = this._SharedService
          .CreateShortLink(get_full_url)
          .pipe(takeUntil(this.ngDestroyed$))
          .subscribe((res) => {
            if (res) {
              this.public_url = res;
              this.ShowTemplate(content, origin, _actionkey, '300px');
            }

            this.loadingShareLink = 0;
          });
      } else {
        this.loadingShareLink = 0;
      }
    }
  }

  ShowDetailConsignment(con : string){
    let list_tracking: string[] = con.split(',');
    let tmp_preview = this._TrackingService.BuildNewListTracking(
      list_tracking.slice(0, 30)
    );
    var shipmentInfo = this.PreviewListTracking.find((x)=> x.tracking_no == con)
    this.GetConsignmentListInfo(
      list_tracking.slice(0, 30)
    ).subscribe(
      (res) => {

        if (res) {
          for (
            let index = 0;
            index < tmp_preview.length;
            index++
          ) {
            let el = tmp_preview[index];

            let find_result = res.find(
              (s) =>
                s.tracking_no == el.tracking_no &&
                s.ref &&
                s.ref.shipment &&
                s.ref.shipment_status &&
                s.ref.icon
            );
            el.isfound = find_result ? true : false;
            if (el.isfound) {
              this.GroupStatus(find_result.ref);
              el.ref = find_result.ref;
              
            }
            shipmentInfo.ref = el.ref;
          }
        }
        if (tmp_preview.length == 1)
          tmp_preview[0].showdetail = true;
        this.Onloading = false;
        this.LoadedQR = false;
      },
      (ex) => {
        this.Onloading = false;
        this.LoadedQR = false;
      }
    );
  }

}
